<template>
  <div>
    <el-drawer
      :visible.sync="addServiceDialog"
      size="50%"
      title="设备"
      :before-close="handleClose"
    >
    <div class="box">
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
         <el-form-item label="绑定机构" required v-if="!form.id">
          <el-input v-model="kw" placeholder="机构名称或电话"></el-input>
            <el-button @click="searchMec">搜索</el-button>
           <el-select v-model="form.mechanism_id" @change="changeMec" placeholder="请选择">
            <el-option
              v-for="item in mechanismList"
              :key="item.value"
              :label="item.mechanism_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="form.device_no" placeholder="设备编号"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="device_name">
          <el-input
            v-model="form.device_name"
            placeholder="如：大门门禁"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备序列号" prop="device_id">
          <el-input
            v-model="form.device_id"
            placeholder="设备背面查看"
            :disabled="form.id"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="device_code" required>
          <el-select v-model="form.device_code" placeholder="请选择">
            <el-option
              v-for="item in deviceCode"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备品牌" prop="brand_id" required>
          <el-select
            v-model="form.brand_id"
            placeholder="请选择"
            @change="changeBrand"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号" prop="model_id" required>
          <el-select v-model="form.model_id" placeholder="请选择">
            <el-option
              v-for="item in modelList"
              :key="item.id"
              :label="item.model_no"
              :value="item.id"
            >
              <div>
                <span>{{ item.model_no }}</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{
                  item.name
                }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接协议"
          required
          v-if="form.device_code == 'DTU'"
        >
          <el-select v-model="form.protocol" placeholder="请选择">
            <el-option
              v-for="item in protocolType"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备账号" v-if="!form.id">
          <el-input
            v-model="form.device_admin"
            placeholder="设备登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备密码" v-if="!form.id">
          <el-input v-model="form.dev_code" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" :loading="loading" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" :loading="loading" @click="submitForm()">添 加</el-button>
      </span>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
import { deviceCode, protocolType } from "@/views/deviceManage/components/dict";
export default {
  data() {
    return {
      kw:'',
      protocolType,
      deviceCode,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      mechanism_id: "",
      brandList: [],
      modelList: [],
      mechanismList:[],
      curMech:{},
      loading: false
    };
  },

  mounted() {
  
    this.getBrand();
  },
  methods: {
    changeMec(id){
      this.mechanismList.forEach(item=>{
        if(item.id == id){
          this.curMech = item
        }
      })
    },
    searchMec() {
      let query = this.kw
      let url = "/user/mastermechanism/queryListPage";
      const numberReg = /^\d/
      let data = {
        type: "teach_paypal",
        pageSize: 20,
        currentPage: 1,
        status:2
      };
      numberReg.test(query)?(data.mechanism_telephone = query) : (data.mechanism_name = query)
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.mechanismList = res.data.data;
        })
    },
    getBrand() {
      this.$axios({
        url: "/device/deviceBrand/queryListPage",
        params: { pageSize: 50 },
      }).then((res) => {
        this.brandList = res.data.data;
      });
    },
    changeBrand(v) {
      this.$axios({
        url: "/device/deviceModel/queryListPage",
        params: {
          brand_id: v,
          type: this.form.dev_code || null,
        },
      }).then((res) => {
        this.modelList = res.data.data;
      });
    },
    open(info) {
      this.mechanismList = []
      this.kw = ''
      this.curMech = {}
      if (info && info.id) {
        this.temp = Object.assign({ }, info);
        this.form = info;
        this.changeBrand(info.brand_id)
      } else {
        this.form = this.temp = Object.assign({ device_admin: "" }, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      if(!this.form.mechanism_id){
        this.$message('请选择绑定门店')
        return
      }
      this.form.latitude = this.curMech.latitude
       this.form.longitude = this.curMech.longitude
      let url = "/device/device/insert";
      this.loading = true
      this.$axios.post(url, this.form).then((res) => {
        this.loading = false
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      }).catch(err=>{
        this.loading = false
      })
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.id = this.form.id;
      data.device_id = this.form.device_id;
      let url = "/device/device/update";
      this.loading = true
      this.$axios.post(url, data).then((res) => {
        this.loading = false
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      }).catch(err=>{
        this.loading = false
      })
    },
     handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>
  
  <style lang="less" scoped>
  .box{
    width: 100%;
    padding: 0 30px;
  }
</style>